import { useContext, useEffect } from "react"
import { CarritoContext } from "../context/CarritoContext"
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'

export const FinalCompra = () => {

  const { compraValida } = useContext(CarritoContext)
  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    if(!compraValida){
      navigate("/inicio")
    }
    // eslint-disable-next-line
  }, [compraValida])
  

  return (    
      <div className="container d-flex justify-content-center" style={{ minHeight: "90vh",paddingTop:"94px" }}>
        {
          compraValida && 
            <div className="p-5 d-flex flex-column justify-content-between">
                  <h1 className="text-center">{t("final_compra_titulo")}</h1>
                  
                  <div className="text-center text-cuaternario" style={{fontSize:'calc(0.9rem + 0.6vw)'}}>
                    <p>{t("final_compra_texto1")}</p>
                    <p>{t("final_compra_texto2")} <a href="mailto:pedidos@altosdeazpitia.com">pedidos@altosdeazpitia.com</a></p>
                  </div>

                  <div className="d-grid justify-content-center text-center text-cuaternario" style={{fontSize:'calc(0.8rem + 0.55vw)'}}>
                    <p>{t("final_compra_texto3")}</p>
                    <p>{t("final_compra_texto4")}</p>
                  </div>                  
            </div>          
        }
      </div >      
  )
}
